function toggleSubChild(trigger) {
  const content = trigger.nextElementSibling;
  if (content && content.classList.contains('sub-child')) {
    const isVisible = content.style.display === 'block';
    content.style.display = isVisible ? 'none' : 'block';


    const chevron = trigger.querySelector('.drawer-menu__chevron.top');
    if (chevron) {
      chevron.classList.toggle('rotated', !isVisible);
    }
  }
}


document.getElementById('DrawerMenuToggler').addEventListener('click', function () {
  console.log("Drawer menu toggler clicked");
  document.querySelectorAll('.drawer-menu__menu-item.tier-1').forEach(trigger => {
    toggleSubChild(trigger);
  });
});


document.addEventListener('click', function (event) {

  const trigger = event.target.closest('.drawer-menu__menu-item');
  if (trigger && /tier-\d+/.test(trigger.className)) {
    toggleSubChild(trigger);
  }
});


/* Language chnage to chnage font-family */

document.addEventListener("DOMContentLoaded", function () {
  const storeLanguage = document.documentElement.lang;
  console.log("Store language is:", storeLanguage);

  if (!storeLanguage) return;

  // Add exact language code as class, e.g., lang-zh-TW
  document.body.classList.add(`lang-${storeLanguage}`);

  const style = document.createElement("style");
  document.head.appendChild(style);

  let fontCSS = "";

  if (storeLanguage === "zh-TW") {
    // Chinese Traditional
    fontCSS = `
      @font-face {
        font-family: 'YuanYunMingTi';
        src: url('https://cdn.shopify.com/s/files/1/0898/1368/0492/files/GenWanMinJP-Regular-4.ttf?v=1747051371') format('truetype');
      }

      @font-face {
        font-family: 'LXGW_WenKai_Mono_TC';
        src: url('https://cdn.shopify.com/s/files/1/0898/1368/0492/files/LXGWWenKaiMonoTC-Regular.ttf?v=1747051047') format('truetype');
      }

      body.lang-zh-TW {
        --gsc-body-font-family: 'YuanYunMingTi';
        --gsc-headings-font-family: 'YuanYunMingTi';
      }
    `;
  } else if (storeLanguage.startsWith("ja")) {
    // Japanese
    fontCSS = `
      @font-face {
        font-family: 'Zen_Kaku_Gothic_Antique';
        src: url('https://cdn.shopify.com/s/files/1/0898/1368/0492/files/GenWanMinJP-Regular-4_409c6819-e449-4c7c-bf60-a3f43a089ca1.ttf?v=1747117188') format('truetype');
      }

      @font-face {
        font-family: 'KleeOne';
        src: url('https://cdn.shopify.com/s/files/1/0898/1368/0492/files/KleeOne-Regular.ttf?v=1747050932') format('truetype');
      }

      body.lang-ja {
        --gsc-body-font-family: 'KleeOne';
        --gsc-headings-font-family: 'Zen_Kaku_Gothic_Antique';
      }
    `;
  }

  // Apply the fonts globally across the store
  fontCSS += `
    body {
      font-family: var(--gsc-body-font-family) !important;
    }

    body *,
    body *::before,
    body *::after,
    span{
      font-family: var(--gsc-body-font-family) !important;
    }

    body h1,
    body h2,
    body h3,
    body h4,
    body h5,
    body h6,
     .h1,
    .h2,
    .h3,
    .h4,
    .h5,
    .h6{
      font-family: var(--gsc-headings-font-family) !important;
    }
  `;

  style.textContent = fontCSS;
});

/* End Language chnage to chnage font-family */